"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgGuideOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.guide_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "guide_outline_svg__transparent_box" },
            React.createElement("path", { className: "guide_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "guide_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "guide_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M9.5 25H26V2H9.5A3.5 3.5 0 006 5.5V26a2.74 2.74 0 000 .5A3.5 3.5 0 009.5 30H26v-2H9.5a1.5 1.5 0 010-3zM8 5.5A1.5 1.5 0 019.5 4H24v19H9.5a3.44 3.44 0 00-1.5.34z" }),
            React.createElement("path", { d: "M16 10a1.5 1.5 0 10-1.5-1.51A1.47 1.47 0 0016 10zM15 12h2v7h-2z" }))));
}
exports.default = SvgGuideOutline;
//# sourceMappingURL=GuideOutline.js.map